import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #111111;
`

const Organization = ({ title = 'Organization', ...rest }: IconProps) => (
  <StyledIcon viewBox="0 0 22 22" title={title} {...rest}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
      <g
        id="surveys-audience-3d"
        transform="translate(-820.000000, -474.000000)"
        stroke="currentColor"
        strokeWidth="0.5"
      >
        <g id="surveys-audience1">
          <g id="Audience" transform="translate(327.000000, 314.000000)">
            <g id="audience-list" transform="translate(104.000000, 51.000000)">
              <g id="table-contents-copy" transform="translate(0.000000, 30.000000)">
                <g id="icon_department" transform="translate(390.000000, 80.000000)">
                  <circle id="Oval" cx="15.862069" cy="13.7931034" r="2.06896552" />
                  <circle id="Oval" cx="4.13793103" cy="13.7931034" r="2.06896552" />
                  <path
                    d="M14.4827586,8.96551724 L14.4827586,8.28793103 C14.4827586,7.79827586 14.2258621,7.34793103 13.8044828,7.09862069 C13.1337931,6.70172414 11.9710345,6.20689655 10.3448276,6.20689655 C8.69758621,6.20689655 7.54241379,6.69862069 6.87862069,7.09482759 C6.46068966,7.34448276 6.20689655,7.79344828 6.20689655,8.28034483 L6.20689655,8.96551724 L14.4827586,8.96551724 Z"
                    id="Shape"
                  />
                  <path
                    d="M8.27586207,20 L8.27586207,19.3224138 C8.27586207,18.8327586 8.01896552,18.3824138 7.59758621,18.1331034 C6.92689655,17.7362069 5.76413793,17.2413793 4.13793103,17.2413793 C2.49068966,17.2413793 1.33551724,17.7331034 0.671724138,18.1293103 C0.253793103,18.3789655 0,18.827931 0,19.3148276 L0,20 L8.27586207,20 Z"
                    id="Shape"
                  />
                  <path
                    d="M20,20 L20,19.3224138 C20,18.8327586 19.7431034,18.3824138 19.3217241,18.1331034 C18.6510345,17.7362069 17.4882759,17.2413793 15.862069,17.2413793 C14.2148276,17.2413793 13.0596552,17.7331034 12.3958621,18.1293103 C11.977931,18.3789655 11.7241379,18.827931 11.7241379,19.3148276 L11.7241379,20 L20,20 Z"
                    id="Shape"
                  />
                  <circle id="Oval" cx="10.3448276" cy="2.06896552" r="2.06896552" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </StyledIcon>
)

Organization.displayName = 'Organization'
Organization.needsWork = true
export default Organization
